import type { FaireProductEntity } from "../../entity_types/product";

export const p_xfzub2rpxr: FaireProductEntity = {
  token: "p_xfzub2rpxr",
  type: "product",
  name: "That Just Dills My Pickle Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c79ff17d53c2ae80232df4997ffdc1e9be11f3a8b714c998abe892ff36edb509.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30f77f9b652e0eb6295e0c003eca4b0f6f21f9ed1c8b23eb76794355f9163dfe.jpeg",
    "https://cdn.faire.com/fastly/dd5118d2e8a1214198a42447fa248967591ac5cfc50defb67eae0ebc6aea199c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/9ea8cfd196e1070107e7adc2a46133db332fda4ec2089a580d024feb46ab8aa7.jpeg",
    "https://cdn.faire.com/fastly/db4db34ff57ab26c35b3206854fbbe04ba46c04051c02557c33d347dcbe1d28a.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are perfect for when you just couldn't be more satisfied. Crisp colors with an attitude that boasts just a hint of salt 😝, wearing these might just make you say \"Well That Just Dills My Pickle\".\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:12.857Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
